<div fxLayout="column" fxLayoutAlign="space-around center">
    <mat-icon class="icon" color="primary" aria-hidden="false" aria-label="Example home icon" fxLayout="column" fxLayoutAlign="center center" style="font-size: 5em;">info</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="start center">
    <div mat-dialog-content fxLayout="column" fxLayoutAlign="center center">
        <h2 style="font-weight: bold; text-align: center; color: #4D514F;">{{'CIERRE.LABEL7' | translate}} {{fecha_meesage | date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha_meesage |date:'O':offsetPipe:idiomaActual}})</h2>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
        <button mat-button style="background-color: #3085d6; color: white" (click)="salir()">{{'CIERRE.ALERT.OK' | translate}} </button>
    </div>
</div>